import { useContext } from 'react';
import { LocationContext, ILocationContext } from './contexts';

export function useLocations(): ILocationContext {
  return useContext(LocationContext);
}
